// useGTM.js
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useGTM = () => {
    const location = useLocation()

    useEffect(() => {
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || []
        // Push a new pageview event whenever the location changes
        window.dataLayer.push({
            event: 'pageview',
            page: location.pathname,
            // Optionally add more properties like search/query params or title
            // title: document.title,
            // fullPath: location.pathname + location.search,
        })
    }, [location])
}

export default useGTM
